// extracted by mini-css-extract-plugin
export var currentStep = "_hi-2";
export var nodeCard = "_hi-0";
export var pathHighlighted = "_hi-1";